import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13 5.142V7.278C13.595 7.625 14 8.263 14 9V11C14 12.103 13.103 13 12 13H8C6.897 13 6 12.103 6 11V9C6 7.897 6.897 7 8 7H9V5H8C5.794 5 4 6.794 4 9V11C4 13.206 5.794 15 8 15H12C14.206 15 16 13.206 16 11V9C16 7.141 14.721 5.589 13 5.142Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8 1H4C1.794 1 0 2.794 0 5V7C0 8.859 1.279 10.411 3 10.858V8.722C2.405 8.375 2 7.737 2 7V5C2 3.897 2.897 3 4 3H8C9.103 3 10 3.897 10 5V7C10 8.103 9.103 9 8 9H7V11H8C10.206 11 12 9.206 12 7V5C12 2.794 10.206 1 8 1Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }